export const DOCUMENT_TYPE_LABELS: Record<string, string> = {
    PRIVATE_TERMS_AND_CONDITIONS: "Abonnementsvilkår",
    PRIVATE_ORDER_CONTRACT: "Kontrakt",
    PRIVATE_SEF_FORM_LEASE: "Telia Delbetaling (SEF)",
    PRIVATE_INSURANCE_PRODUCT_INFORMATION_DOCUMENT_SCREEN_AND_EXTRA: "Telia IPID Produktblad",
    PRIVATE_INSURANCE_CERTIFICATE: "Forsikringsbevis",
    BUSINESS_INSURANCE_CERTIFICATE: "Forsikringsbevis",
    BUSINESS_INSURANCE_PRODUCT_INFORMATION_DOCUMENT_SCREEN_AND_EXTRA:
        "IPID Produktblad Telia Forsikring skjermforsikring og plussforsikring",
    BUSINESS_TERMS_AND_CONDITIONS: "Abonnementsvilkår",
    BUSINESS_ORDER_CONTRACT: "Kontrakt",
    BUSINESS_SIGNATURE_HOLDERS_BRREG: "Signaturinnehavere",
    PRIVATE_PARCEL_LABEL: "Fraktseddel for svitsj retur",
    PRIVATE_UPGRADED_DEVICES_PN_REPORT_EXTERNAL: "Følgebrev for svitsj retur",
    PRIVATE_TERMS_SWITCH: "Svitsjavtalen",
    PRIVATE_TERMS_TF_SWITCH: "Telia Norge Svitsj vilkår",
    PRIVATE_TERMS_TF_SWITCH_INSURANCE: "Svitsj forsikringsvilkår",
    PRIVATE_TERMS_TF_DOWNPAYMENT: "Telia Finance leievilkår",
    PRIVATE_INSURANCE_PRODUCT_INFORMATION_DOCUMENT_SWITCH: "IPID Produktblad Telia Forsikring Svitsj",
    PRIVATE_SEF_FORM_SWITCH: "Telia Svitsj standardiserte europeiske opplysninger om forbrukerkreditt (SEF)",
    ESIM_ACTIVATION_INSTRUCTIONS: "eSIM-aktiveringsinstruksjoner",
    BUSINESS_TERMS_INSURANCE_STANDARD: "Telia forsikringsvilkår",
    BUSINESS_TERMS_INSURANCE_STANDARD_PREOWNED: "LIKE FIN forsikringsvilkår",
    PRIVATE_TERMS_INSURANCE_STANDARD: "Telia forsikringsvilkår",
    PRIVATE_TERMS_INSURANCE_STANDARD_PREOWNED: "LIKE FIN forsikringsvilkår",
    PRIVATE_OFFER_SUMMARY: "Avtalesammendrag",
};
